import { UseSearchBoxProps } from 'react-instantsearch';

const TIMEOUT: number = 500;

let timerId: number | undefined = undefined;

// debounce queries
export const queryHook: UseSearchBoxProps['queryHook'] = (query, search) => {
  if (timerId) {
    window.clearTimeout(timerId);
  }
  timerId = window.setTimeout(() => search(query), TIMEOUT);
};
